<template>
  <div class="card-header pt-3 pb-0 position-relative">
    <h4 class="card-title mb-4">
      {{ $t("account-page-notif-control.schedule_pre_checkin_notice.title") }}
    </h4>

    <!-- Navigation Tabs -->
    <b-tabs
      nav-class="nav-tabs"
      content-class="mt-3"
      v-model="activeTab" 
    >
      <!-- Email Tab -->
      <b-tab 
        title="Email" 
        :active="activeTab === 0"  
      >
        <EmailPreCheckinNotice v-if="activeTab === 0" />
      </b-tab>

      <!-- SMS Tab -->
      <b-tab 
        title="SMS"
        v-if="facility.has_pms"  
        :active="activeTab === 1"  
      >
        <SmsPreCheckinNotice v-if="activeTab === 1" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import EmailPreCheckinNotice from './pre-checkin-tab/email/EmailPreCheckinNotice.vue';
import SmsPreCheckinNotice from './pre-checkin-tab/sms/SmsPreCheckinNotice.vue';

export default {
  name: "ScheduleNotice",
  components: {
    EmailPreCheckinNotice,
    SmsPreCheckinNotice
  },
  data() {
    return {
      facility: {}, 
      activeTab: 0,  
    };
  },
  mounted() {
    this.facility = window._app_facility;
  },
};
</script>
